import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { SiteSettingsProvider } from "@/context/SiteSettingsContext";
import "@/App.css";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import PracticeAreas from "@/components/PracticeAreas";
import PracticeAreaDetails from "@/components/PracticeAreaDetails";
import ProblematicaSection from "@/components/ProblematicaSection";
import Attorneys from "@/components/Attorneys";
import CaseResults from "@/components/CaseResults"; // Removed from view but keeping import for potential future use
import Testimonials from "@/components/Testimonials";
import FeesSection from "@/components/FeesSection";
import ConsultationSection from "@/components/ConsultationSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import CTABanner from "@/components/CTABanner";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import BookingModal from "@/components/BookingModal";
import SEOHead from "@/components/SEOHead";
import ServicePage from "@/pages/ServicePage";
import AdminPage from "@/pages/AdminPage";
import ClientPortal from "@/pages/ClientPortal";
import ClientDashboard from "@/pages/ClientDashboard";
import DiagnosticoClientePage from "@/pages/DiagnosticoClientePage";
import { Toaster } from "sonner";

function HomePage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [preselectedCaseType, setPreselectedCaseType] = useState("");
  const [preselectedAttorney, setPreselectedAttorney] = useState("");
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  const openBooking = (caseType = "", attorney = "") => {
    setPreselectedCaseType(caseType);
    setPreselectedAttorney(attorney);
    setModalOpen(true);
  };

  return (
    <div className="App overflow-x-hidden" data-testid="app-container">
      <SEOHead />
      <Toaster position="top-center" richColors />
      <Header onBookingOpen={() => openBooking()} />
      <HeroSection onBookingOpen={() => openBooking()} />
      <AboutSection />
      <ProblematicaSection />
      <PracticeAreas />
      <PracticeAreaDetails onBookingOpen={(caseType) => openBooking(caseType)} />
      <FeesSection onBookingOpen={() => openBooking()} />
      {/* Sección de equipo eliminada - sin fotos de personas */}
      <Testimonials />
      <ConsultationSection />
      <FAQSection onBookingOpen={() => openBooking()} />
      <ContactSection />
      <CTABanner onBookingOpen={() => openBooking()} />
      <Footer onBookingOpen={() => openBooking()} />
      <FloatingButtons />
      <BookingModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        preselectedCaseType={preselectedCaseType}
        preselectedAttorney={preselectedAttorney}
      />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SiteSettingsProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:serviceId" element={<ServicePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/portal" element={<ClientPortal />} />
            <Route path="/portal/dashboard" element={<ClientDashboard />} />
            <Route path="/diagnostico/:token" element={<DiagnosticoClientePage />} />
            {/* Redirecciones SEO amigables */}
            <Route path="/permiso-autoconsumo" element={<Navigate to="/services/permisos-autoconsumo" replace />} />
            <Route path="/controles-volumetricos" element={<Navigate to="/services/controles-volumetricos" replace />} />
            <Route path="/servicios" element={<Navigate to="/#practice-areas" replace />} />
            <Route path="/contacto" element={<Navigate to="/#contact" replace />} />
          </Routes>
        </SiteSettingsProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
